import React from 'react';

const HistoryIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1682 12.9707V14.2204V15.0536H15.418"
      stroke={props.color || '#000000'}
      strokeWidth="1.49968"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9575 18.5205C16.1429 18.5205 17.915 16.7484 17.915 14.563C17.915 12.3775 16.1429 10.6055 13.9575 10.6055C11.7712 10.6055 10 12.3775 10 14.563C10 16.7484 11.7712 18.5205 13.9575 18.5205"
      stroke={props.color || '#000000'}
      strokeWidth="1.49968"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.015 16.2117H3.84483C2.87304 16.2117 2.08594 15.4246 2.08594 14.4528V3.89951C2.08594 2.92773 2.87304 2.14062 3.84483 2.14062H12.6393C13.6111 2.14062 14.3982 2.92773 14.3982 3.89951V10.629"
      stroke={props.color || '#000000'}
      strokeWidth="1.49968"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.33594 5.55664H10.8348" stroke={props.color || '#000000'} strokeWidth="1.49968" strokeLinecap="round" />
    <path d="M5.33594 8.88867H10.0016" stroke={props.color || '#000000'} strokeWidth="1.49968" strokeLinecap="round" />
    <path d="M5.33594 12.2227H7.50215" stroke={props.color || '#000000'} strokeWidth="1.49968" strokeLinecap="round" />
  </svg>
);

export default HistoryIcon;
